<template>
  <div>
    <h1 class="mt-0 mb-15 text-center bold-text">Sign In</h1>
    <form>
      <div class="row pl-10 pr-10">
        <div class="col mb-20">
          <base-input
            v-model="form.username.value"
            type="text"
            id="username"
            label="Username"
            placeholder="Username"
            role="username"
          />
        </div>
        <div class="col">
          <base-input
            v-model="form.password.value"
            :type="inputType"
            id="password"
            label="Password"
            placeholder="Password"
            role="password"
          >
            <template v-slot:tag>
              <a @click="toggleType" class="pull-right show-password">
                <small> Show <i class="fas fa-eye"></i> </small>
              </a>
            </template>
          </base-input>
        </div>
      </div>

      <div class="errors">
        <p v-if="invalidSession" class="bg-danger p-15 text-center">{{ invalidSession }}</p>
        <p v-if="errors.length" class="bg-danger p-15 text-center">
          <template v-for="(error, idx) in errors">
            <div :key="idx">{{ error.message }}</div>
          </template>
        </p>
      </div>
      <div class="row pl-10 pr-10 mt-20">
        <div class="col-lg-6 p-0">
          <button
            data-testid="iap-sign-in"
            @click.prevent="triggerLogin"
            class="btn mat btn-primary pl-25 pr-25"
          >
            Sign In
          </button>
        </div>
        <div class="col-lg-6 mt-5 p-0">
          <router-link :to="{ name: 'forgot-password' }" class="pull-right"
            >Forgot your password?</router-link
          >
        </div>
      </div>
      <hr />

      <p class="mt-30">
        Don't have an account? <router-link :to="{ name: 'sign-up' }"> Sign up here </router-link>
      </p>
    </form>
  </div>
</template>
<script>
  import { mapActions } from 'vuex';
  export default {
    name: 'LoginForm',

    data() {
      const invalidSession = this.$route.query.invalidSession
        ? 'Your session has expired. Please sign in to access your account.'
        : null;
      return {
        errors: [],
        invalidSession,
        invalidCredentials:
          'We’re sorry, but we do not recognize that Username or Password. Please try again.',
        form: {
          username: {
            value: '',
            validate() {
              return this.value.length > 3;
            },
          },
          password: {
            value: '',
            validate() {
              return this.value.length > 4;
            },
          },
        },
        inputType: 'password',
      };
    },

    methods: {
      ...mapActions('user', ['login']),
      toggleType() {
        return this.inputType === 'password'
          ? (this.inputType = 'text')
          : (this.inputType = 'password');
      },

      async triggerLogin() {
        try {
          this.errors = [];
          if (this.validateForm()) {
            await this.login({
              username: this.form.username.value,
              password: this.form.password.value,
            });
          }
        } catch (err) {
          if (err && err.status == 401) this.errors.push({ message: this.invalidCredentials });
        }
      },
      validateForm() {
        const { username, password } = this.form;

        if (!username.validate() || !password.validate()) {
          Object.keys(this.form).forEach((input) => {
            !this.form[input].validate() &&
              this.errors.push({
                message: `Please enter a valid ${input}`,
              });
          });
        }

        return this.errors.length ? false : true;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .show-password {
    cursor: pointer;
  }
</style>
